import React, { useState,useRef } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CToaster
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons'
import VactrackAlert  from 'src/components/vactrack/VactrackAlert';
import { postData } from 'src/utils/apiService'
import { useNavigate, useParams } from 'react-router-dom';

const Welcome = () => {

  //Router
  const navigate = useNavigate();

  const { token } = useParams();
//   console.log(`TOKEN FOUND ${token}`);

  // States
  const [toast,addToast] = useState(0);
  const [validated,setValidated] = useState(false);
  const toaster = useRef();
  const errorToast = VactrackAlert("Please enter the valid data");

  const [passwordInput,setPasswordInput] = useState("");
  const [isPasswordValid,setIsPasswordValid] = useState(false);
  const [errorText,setErrorText] = useState("Password cannot be empty");

  const [reTypepasswordInput,setReTypePasswordInput] = useState("");
  const [rePasswordValid,setRePasswordValid] = useState(false);
  const [reErrorText,setReErrorText] = useState("Password cannot be empty");



  const nextPage = '/login';

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{12,}$/;
    if (passwordRegex.test(password)) {
      return true;
    } else {
       return false;
    }
  };

  const handlePasswordInput = (event) => {
    setPasswordInput(event.target.value);
    if(!validatePassword(event.target.value)){
      setIsPasswordValid(false);
      setErrorText("Password should be at least 12 characters long and include at least one lowercase letter, one uppercase letter, one number, and one symbol.");
    }else{
      setIsPasswordValid(true);
    //   setErrorText("");
    }
  }

  const handleRePasswordInput = (event) => {
    setReTypePasswordInput(event.target.value);
    if(event.target.value !== passwordInput){
      setRePasswordValid(false);
      setReErrorText("Password and Re-type password should be same");
    }else{
      setRePasswordValid(true);
    //   setReErrorText("");
    }
  }


  const handleSubmit = async(event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      addToast(errorToast);
    //   setIsPasswordValid(false);
    //   setRePasswordValid(false);
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    // console.log(passwordInput);
    // console.log(reTypepasswordInput);

    // console.log(passwordInput !== reTypepasswordInput);

    if(passwordInput !== reTypepasswordInput){
      addToast(VactrackAlert("Password and Re-type password should be same"));
    //   setIsPasswordValid(false);
    //   setRePasswordValid(false)
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    setValidated(true);
    if(form.checkValidity() === true){
      event.preventDefault();
      const response = await postData("/auth/welcome", {
        "token":token,
        "password":passwordInput
      });

      if(response.statusCode !== 200){
        addToast(VactrackAlert(response.message));
      }else{
        navigate(nextPage);
      }
      
    }
    event.preventDefault();
  }
  

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CToaster className="p-3" placement="top-end" push={toast} ref={toaster} />
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm className='needs-validation' noValidate validated={validated} onSubmit={handleSubmit}>
                    <h1>Welcome</h1>
                    <p className="text-medium-emphasis">Please enter a new secure password</p>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        feedbackValid=""
                        feedbackInvalid={errorText}
                        id='password1'
                        valid={isPasswordValid}
                        invalid={!isPasswordValid}
                        onChange={(e) => handlePasswordInput(e)}
                        required
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Re-Type Password"
                        autoComplete="current-password"
                        feedbackValid=""
                        valid={rePasswordValid}
                        invalid={!rePasswordValid}
                        feedbackInvalid={reErrorText}
                        id='password2'
                        onChange={(e) => handleRePasswordInput(e)}
                        required
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs={6}>
                        <CButton color="primary" className="px-4" type="submit">
                          Set Password
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Welcome
